const networks = {
  public: 'public',
  test: 'test',
  local: 'local',
}

const hostnameToNetworkType = hostname => {
  if (hostname === 'kurdscan.org' || hostname === 'publicnet.local')
    return networks.public
  else if (hostname === 'testnet.steexp.com' || hostname === 'testnet.local')
    return networks.test
  else return networks.local
}

export {networks as default, hostnameToNetworkType}



// WEBPACK FOOTER //
// ./src/lib/stellar/networks.js